import { Module } from 'vuex'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { LangState } from './types'
import { RootState } from '../types'
import config from 'config'

export const initState: LangState = {
  locale: config.i18n.fallback_locale,
  translations: {}
}

const namespaced = true

export const LANG: Module<LangState, RootState> = {
  namespaced,
  actions,
  mutations,
  getters,
  state: initState
}
